import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router";
import LoginRequiredRoute from "./utils/LoginRequiredRoute";
import LoginPage from "./pages/LoginPage";
import JoinPage from "./pages/JoinPage";
import FindIdPasswordPage from "./pages/FindIdPasswordPage";
import FireOnPage from "./pages/FireOnPage";
import WithdrawPage from "./pages/WithdrawPage";
import UserAccountPage from "./pages/UserAccountPage";
import Main from "./Main";
import FindIdPasswordCompletePage from "./pages/FindIdPasswordCompletePage";
import NoticeBoardPage from "./pages/NoticeBoardPage";

function App() {
  return (
    <Routes>
      <Route path="join" element={<JoinPage />} />
      <Route path="withdraw" element={<WithdrawPage />} />
      <Route path="find-id-password" element={<FindIdPasswordPage />} />
      <Route
        path="find-id-password/complete"
        element={<FindIdPasswordCompletePage />}
      />
      <Route path="user-account" element={<UserAccountPage />} />
      <Route path="notice/*" element={<NoticeBoardPage />} />
      <Route path="login" element={<LoginPage />} />
      <Route
        path="*"
        element={
          <LoginRequiredRoute>
            <Main />
          </LoginRequiredRoute>
        }
      />
    </Routes>
  );
}

export default App;
